export default {
  hero: {
    badge: "Business Consulting",
    titlePrefix: "Build Your Business ",
    titleHighlight: "the Right Way",
    subtitle: "From LLC formation and licensing to business structure and strategy — we guide entrepreneurs at every step.",
    cta: {
      book: "Book a Consultation",
      explore: "Explore Services"
    },
    stats: {
      llc: "Formation Support",
      guidance: "Personalized Guidance",
      setup: "Business Setup"
    }
  },
  services: {
    hero: {
      badge: "What We Offer",
      titlePrefix: "Business ",
      titleHighlight: "Consulting Services",
      subtitle: "Comprehensive guidance to help you build, structure, and grow a legitimate and scalable business."
    },
    items: {
      llc: {
        title: "Business Setup & LLC Formation",
        desc: "We guide you through the process of establishing your business entity — from choosing the right structure to forming an LLC.",
        benefits: [
          "Guidance on LLC vs. other structures",
          "Step-by-step formation guide",
          "Operating agreements",
          "EIN and bank account guidance",
          "Professional network connection",
          "Starting the right way"
        ],
        forWho: "Entrepreneurs ready to formalize."
      },
      compliance: {
        title: "Licensing & Compliance",
        desc: "Navigate business licenses and permits. We help you understand what your business needs to operate legally.",
        benefits: [
          "Identificación de licencias",
          "Resumen de cumplimiento",
          "Lista de requisitos de permisos",
          "Guía de plazos y renovaciones",
          "Referencias de expertos",
          "Evitar complicaciones legales"
        ],
        forWho: "Owners needing legal guidance."
      },
      strategy: {
        title: "Structure & Strategy",
        desc: "Build a solid foundation with the right structure, systems, and growth strategy.",
        benefits: [
          "Organizational design",
          "Revenue & pricing strategy",
          "Operational workflows",
          "Scalability roadmap",
          "Goal frameworks",
          "Competitive positioning"
        ],
        forWho: "Owners looking for sustainable growth."
      },
      network: {
        title: "Professional Network",
        desc: "Access our trusted network of licensed professionals — attorneys, accountants, and more.",
        benefits: [
          "Referrals to attorneys",
          "Connections with CPAs",
          "Financial advisors",
          "Industry-specific experts",
          "Warm introductions",
          "Ongoing coordination"
        ],
        forWho: "Owners needing specialized support."
      }
    },
    common: {
      forWho: "Who it's for:",
      book: "Book a Consultation"
    }
  },
  whoFor: {
    hero: {
      badge: "Who It's For",
      titlePrefix: "Is This ",
      titleHighlight: "For You?",
      subtitle: "Our business consulting services are designed for determined individuals ready to build something real."
    },
    items: {
      p1: { title: "First-Time Entrepreneurs", desc: "You have a great idea but don't know where to start. We help you build the base from day one." },
      p2: { title: "Small Business Owners", desc: "Already operating but need to formalize, optimize, or scale." },
      p3: { title: "Freelancers Going Formal", desc: "Ready to transition from freelancer to business owner." },
      p4: { title: "Growing Businesses", desc: "Growing fast and need better systems and structure." },
      p5: { title: "Online Business Owners", desc: "Digital businesses needing compliance and solid structure." },
      p6: { title: "Local Service Businesses", desc: "Local services needing licenses and permits to operate." }
    }
  },
  process: {
    hero: {
      badge: "The Process",
      titlePrefix: "How It ",
      titleHighlight: "Works",
      subtitle: "A simple process designed to get your business moving — fast."
    },
    items: {
      s1: { title: "Book a Consultation", desc: "Schedule a free strategy session to discuss your business goals." },
      s2: { title: "Business Assessment", desc: "We identify gaps and map out the right path forward." },
      s3: { title: "Custom Action Plan", desc: "Receive a personalized roadmap with clear steps and priorities." },
      s4: { title: "Execute & Grow", desc: "Implement your plan with our ongoing support." }
    }
  },
  cta: {
    titlePrefix: "Ready to Build Your Business ",
    titleHighlight: "the Right Way?",
    subtitle: "Stop guessing and start building with confidence. Book a free consultation today.",
    cta: {
      book: "Book a Free Consultation",
      services: "See All Services"
    }
  },
  disclaimer: {
    title: "Legal Disclaimer",
    text: "We do not offer legal or financial advice. All decisions should be made in consultation with a licensed professional."
  }
};
